import { call, select, takeEvery } from 'redux-saga/effects';

import { getSessionProjectId, getSessionUserId } from '@app/selectors';
import type { bgProcessFinished } from '@app/sockets/socketActions';
import * as socketActions from '@app/sockets/socketActions';

function* showProcessFinishedToast({ payload }: ReturnType<typeof bgProcessFinished>) {
    const userId: string = yield select(getSessionUserId);
    const sessionId: string = yield select(getSessionProjectId);
    if (typeof payload === 'undefined' || Number(userId) !== payload.user.id) {
        return;
    }
    let title: string;
    let activityText: string | undefined;
    let activityClick: undefined | (() => void);

    // preventing to show upload toast in apps page
    if (window.location.pathname.includes('/apps/') && payload.type === 'integration-file-import') {
        return;
    }

    const pageRef = payload.params.project_id !== sessionId ? payload.info?.project_name : undefined;

    switch (payload.type) {
        case 'file-import':
            title =
                Number(payload.info?.files?.length) > 1
                    ? `${payload.info?.files?.length} files were uploaded`
                    : 'Your file was uploaded';
            if (pageRef) {
                title += ` to ${pageRef}`;
            }
            break;
        case 'bulk-apply-automations':
            title = 'All done with keys';
            if (pageRef) {
                title += ` in ${pageRef}`;
            }
            break;
        case 'create-branch-reindex':
            title = `Keys ready in ${payload.params.branch_name} branch`;
            break;
        default:
            return;
    }

    const activityToast = new CustomEvent('activityToast', {
        detail: {
            type: 'finished',
            title,
            processId: payload.id,
            projectId: payload.params.project_id,
            branchId: payload.params.branch_id,
            openActivityText: activityText,
            openActivityClick: activityClick,
        },
    });

    yield call(window.dispatchEvent, activityToast);
}

export default function* initActivitySagas() {
    yield takeEvery([socketActions.bgProcessFinished.match], showProcessFinishedToast);
}
